"use client";
import Link from "next/link";
import { Button, BlockWrapper, H1, Text } from "@/shared/components";
import { useErrorConfig } from "../_providers/errorConfigProvider";

const DEFAULT_ERROR_TITLE = "Страница не найдена";
const DEFAULT_ERROR_CONTENT =
  "Запрашиваемая страница не существует или была перемещена.";

export default function GlobalError({
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const { title, content } = useErrorConfig();
  const displayTitle = title || DEFAULT_ERROR_TITLE;
  const displayContent = content || DEFAULT_ERROR_CONTENT;

  return (
    <BlockWrapper>
      <div className="flex flex-col gap-6 py-20">
        <H1>{displayTitle}</H1>
        <Text className="max-w-2xl text-base leading-[1.2] text-tag-foreground">
          {displayContent}
        </Text>
        <div className="flex gap-4 items-center">
          <Button onClick={reset} variant="outline">
            Попробовать снова
          </Button>
          <Link href="/">
            <Button>На главную</Button>
          </Link>
        </div>
      </div>
    </BlockWrapper>
  );
}
